import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

gsap.config({
	// nullTargetWarn: false
})

export let initAnimations, Banner, BannerMenus, BannerVouchers, About

initAnimations = () => {
	Banner()
	BannerMenus()
	BannerVouchers()
	About()
}

Banner = () => {

	return

	const banner = document.querySelector('.banner')

	if (!banner || window.isLivePreview) return

	console.log('bannerAnimation')

	const header = document.querySelector('.header')
	const heading = banner.querySelectorAll('.line')
	const video = banner.querySelector('.banner__video')

	const tl = gsap.timeline({
		delay: window.initialLoad ? 1 : 0
	})

	tl.fromTo(video, {
		scale: 1.2,
		opacity: 0,
		filter: 'blur(6px)',
	}, {
		scale: 1,
		opacity: 1,
		filter: 'blur(0px)',
		duration: 1.8,
		ease: 'power2.inOut',
	})

	tl.fromTo(heading, {
		yPercent: 108
	}, {
		yPercent: 0,
		duration: 1.6,
		stagger: 0.1,
		ease: 'expo',
	}, '-=0.4')

	if (window.initialLoad) {
		tl.fromTo(header, {
			y: -200,
			opacity: 0
		}, {
			y: 0,
			opacity: 1,
			duration: 1.4,
			ease: 'expo.out'
		}, '-=1.6')
	}
}

About = () => {
	const els = document.querySelectorAll('.about')

	if (!els.length || window.isLivePreview) return

	els.forEach(el => {
		const heading = el.querySelectorAll('.about__heading .line')

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: el,
				start: 'top 60%',
				invalidateOnRefresh: true,
				once: true
			}
		})

		tl.fromTo(heading, {
			yPercent: 108
		}, {
			yPercent: 0,
			duration: 2,
			stagger: 0.1,
			ease: 'expo',
		})

	})
}

BannerMenus = () => {
	const els = document.querySelectorAll('.banner-menus')

	if (!els.length || window.isLivePreview) return

	els.forEach(el => {
		const heading = el.querySelectorAll('.banner-menus__heading .line')
		const taglines = document.querySelectorAll('.banner-menus__tagline')

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: el,
				start: 'top 60%',
				invalidateOnRefresh: true,
				once: true
			}
		})

		tl.fromTo(heading, {
			yPercent: 108
		}, {
			yPercent: 0,
			duration: 2,
			stagger: 0.1,
			ease: 'expo',
		})

		taglines.forEach(el => {
			const char = el.querySelectorAll('.char')

			tl.fromTo(char, {
				opacity: 0
			}, {
				opacity: 1,
				stagger: 0.06,
				duration: 1.2
			}, '-=0.6')
		})

	})
}

BannerVouchers = () => {
	const el = document.querySelector('.vouchers')

	if (!el || window.isLivePreview) return

	let heading = el.querySelectorAll('.vouchers__heading .line'),
		text = document.querySelectorAll('.vouchers__text')

	gsap.fromTo(heading, {
		yPercent: 108
	}, {
		yPercent: 0,
		duration: 2,
		stagger: 0.1,
		ease: 'expo',
		delay: 2.4,
	})

	gsap.fromTo(text, {
		opacity: 0,
	}, {
		opacity: 1,
		duration: 1,
		delay: 2.6,
	})
}

export default () => { }